export default __webpack_public_path__ + "d792edf7c3082abf886e102aaa12b2b2.svg";